"use strict"

import * as m from "./mutations"
export const mutation = m

import * as q from "./queries"
export const query = q

import * as s from "./subscriptions"
export const subscription = s
